export default "/fonts/vendor/mdui/dist/roboto/Roboto-BoldItalic.woff?d85436fa35b78a399a68b44491fa3478";